import { app } from "js/namespaces";
import { buildVersion } from "js/config";
import { getSymbolCmdOrCtrl, trackActivity } from "../../../core/utilities/utilities";
import isConnected from "js/core/utilities/isConnected";
import { ShowOfflineDialog } from "js/react/components/Dialogs/BaseDialog";
import { UIController } from "js/editor/dialogs/UIController";
import firebase from "js/firebase";
import AppController from "js/core/AppController";
import PresentationEditorController, { PanelType } from "../PresentationEditorController";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.HELP_MENU);

async function getAppcuesLaunchpad() {
    const accountId = 84430;
    const user = firebase.auth().currentUser;
    const url = `https://api.appcues.com/v1/accounts/${accountId}/users/${user.uid}/taco?url=${window.location}`;
    const res = await fetch(url);
    const data = await res.json();
    logger.info("[Appcues Launchpad]", data);
    return data;
}

export function getHelpMenu(source, includeBuildInfo) {
    const menu = {
        overwriteTriggerHandler: true,
        items: [
            { value: "get_help", label: "Get Help", icon: "support" },
            { value: "take_tour", label: "Take Tour", icon: "tour" },
            { label: "Tutorials", icon: "ondemand_video", type: "menu", menu: {
                items: async close => {
                    let items = [];
                    if (app.mainView?.editorView?.slideGrid) {
                        items.push({
                            type: "info",
                            label: "<center>Tutorials are not currently designed <br>to work with the Organize View. <br><br>Please return to the Editor View <br>and try again.</center>",
                        });
                    } else {
                        const data = await getAppcuesLaunchpad();
                        items = data.contents
                            .sort((a, b) => a.name > b.name ? 1 : -1)
                            .map(content => {
                                return {
                                    label: content.name,
                                    value: content.id,
                                };
                            });
                        if (!items.length) {
                            items.push({
                                type: "info",
                                label: "<center>Nothing to see here.<br>Check back later!</center>",
                            });
                        }
                    }
                    return items;
                },
                callback: flowId => {
                    window.Appcues.show(flowId);
                    trackActivity("HelpCenter", "PlayTour", null, null, { source, flowId }, { audit: false });
                },
            } },
            { value: "give_feedback", label: "Give Feedback", icon: "edit" },
            { type: "divider" },
            { value: "keyboard_shortcuts", label: "Keyboard Shortcuts", shortcut: `${getSymbolCmdOrCtrl()} ?` },
        ],
        callback: action => {
            switch (action) {
                case "get_help":
                    if (!isConnected.connected) {
                        ShowOfflineDialog();
                        return;
                    }
                    window.zendeskInit();
                    window.zE(() => {
                        window.zE.activate();
                    });
                    break;
                case "give_feedback":
                    if (!isConnected.connected) {
                        ShowOfflineDialog();
                        return;
                    }
                    UIController.showFeedbackDialog();
                    break;
                case "keyboard_shortcuts":
                    AppController.setExternalActivePanel(PanelType.SHORTCUTS);
                    break;
                case "take_tour":
                    AppController.showTour();
                    break;
            }
        }
    };

    if (includeBuildInfo) {
        menu.items.push({ type: "divider" });
        menu.items.push({ type: "info", label: `Build ${buildVersion}` });
    }

    return menu;
}

